import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  variants: {
    bodyLarge: {
      fontSize: "20px",
      lineHeight: "32px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
    },
    body: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
    },
    label: {
      fontSize: "14px",
      lineHeight: "16px",
      fontFamily: "riforma.regular",
    },
    labelSmall: {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      textTransform: "uppercase",
    },
    numbersXXL: {
      fontSize: "110px",
      lineHeight: "110px",
      fontFamily: "riforma.regular",
    },
    numbersXL: {
      fontSize: "88px",
      lineHeight: "76px",
      letterSpacing: "0.01em",
      fontFamily: "riforma.regular",
    },
    numbersL: {
      fontSize: "56px",
      lineHeight: "56px",
      letterSpacing: "-0.56px",
      fontFamily: "riforma.bold",
      fontWeight: 700,
    },
  },
})

export default theme
